<script>
  import PregaoLeiloeiro from '../pregao-leiloeiro/Main'

  export default {
    name: 'PregaoLeiloeiroMobile',
    mixins: [PregaoLeiloeiro],
    data () {
      return {
      }
    }
  }
</script>

<template>
  <div class="h-full" :class="classLanceOnline">
    <div class="pregao-leiloeiro-mobile thema1 h-full" :class="{'isLoading': isLoading}">
      <div class="header-pregao">
        <div class="lote-info">
          <span>Lote {{ lote.numero }}</span>
          <small>{{ Number(lote.quantidadeLeiloes) + 1}}º LEILÃO</small>
          <span v-if="proximoLote !== null">Próximo lote: {{proximoLote}}</span>
        </div>

        <div class="comitente-info">
          <div class="hora">
            <relogio></relogio>
          </div>

          <div class="comitente">
            <img :src="lote.comitente.imagemUrl"/>
          </div>
        </div>
      </div><!---->

      <div class="body-pregao">
        <div class="left-pregao">
          <div class="item">
            <h4>Lance Atual</h4>
            <span class="valorAtual show-value" :class="{novoLance: hasNovoLance}">{{ valor | moeda }}</span>
          </div><!---->

          <div class="item">
            <h4>Valor Avaliação</h4>
            <span class="avaliacao show-value">{{ lote.valorAvaliacao | moeda }}</span>
          </div><!---->
        </div><!-- END Left -->

        <div class="center-pregao">
          <div class="item" :class="{online: apelido !== 'PLATEIA' && apelido !== '-'}">
            <h4>Arrematante</h4>
            <div class="arrematante show-value">
              <strong>{{ apelido }}</strong>
              <span>{{ lanceLocalidade }}</span>
            </div>
          </div><!---->

          <div class="item" :class="minimoStyle">
            <h4>Valor Mínimo</h4>
            <span class="minimo show-value">{{ lote.valorMinimo | moeda }}</span>
          </div><!---->
        </div><!-- END Center -->

        <div class="right-pregao">
          <div class="item">
            <h4 :style="'color: ' + colorStatus">{{ statusLote }}</h4>
            <span class="cronometro show-value" :class="{'lance-danger': countDownTimer <= calcPercentTimer(30)}">
              {{ timerPregaoFormatado }}
            </span>
          </div>
        </div><!-- END Right -->

        <div class="left-pregao pd-add">
          <h3 :class="{'lote-sucata': lote.condicao === 7}">{{ tituloLote }}</h3>
          <p>{{ descricaoLote }}</p>
          <p>{{ observacaoLote }}</p>
        </div><!-- END Left -->

        <div class="image center-pregao" :class="'lote-img-status' + lote.status">
          <img ref="loteImagem" :src="lote.imagem">
        </div>

        <div class="show-fip">
          <div class="fip-item">
            <h5>Fipe/Lance</h5>
            <span>{{ fipeLance }}</span>
          </div><!---->

          <div class="fip-item">
            <h2>% FIPE</h2>
          </div>

          <div class="fip-item">
            <h5>Avaliação</h5>
            <span>{{ porcentagemAvaliacao }}%</span>
          </div><!---->

          <div class="fip-item">
            <h5>Minimo</h5>
            <span>{{ porcentagemMinimo }}%</span>
          </div><!---->

          <div class="fip-item">
            <h5>Tabela Fipe</h5>
            <span>R$ {{ lote.valorTabelaFipe | moeda }}</span>
          </div><!---->
        </div>
      </div>

      <div class="footer-pregao">
        <div> <!-- class="vendidos" -->
          <span>Vendidos<div class="no-select" v-shortkey="['enter']" @shortkey="renovarTempo()"></div></span>
          <p>{{ stats.vendidos }}</p>
        </div>
        <div>
          <span>Condicionais</span>
          <p>{{ stats.condicionais }}</p>
        </div>
        <div>
          <span>Não Vendidos</span>
          <p>{{ stats.naoVendidos }}</p>
        </div>
        <div>
          <span>Saldo</span>
          <p>{{ totalSaldo }}</p>
        </div>
        <div>
          <span>Saldo Sucata</span>
          <p>{{ totalSaldoSucata }}</p>
        </div>
        <div>
          <span>Total</span>
          <p>{{ totalLotes }}</p>
        </div>
        <div>
          <span>Total Vendas</span>
          <p>R$ {{ stats.totalVendas | moeda }}</p>
        </div>
        <div>
          <span style="white-space: nowrap">Val. Condicionais</span>
          <p>R$ {{ stats.valoresCondicionais | moeda }}</p>
        </div>
        <div>
          <span style="white-space: nowrap">% Venda Comitente</span>
          <p><small style="font-size: 11px">Atual:</small> {{ percentualVenda }}</p>
          <p style="font-size: 11px; margin-top: -5px" v-if="null !== stats.mediaFipeAnterior">Anterior: {{ percentualVendaAnterior }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?58e76caf